import { Component, input } from '@angular/core';

@Component({
  selector: 'era-title',
  templateUrl: './title.component.html',
  styleUrls: ['./title.component.scss'],
})
export class TitleComponent {
  readonly isDetail = input(false);
}
